import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSingleColumn } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import { EFFECTIVE_DATE, LAST_UPDATED, INTRO, SECTIONS, CONTACT } from './LenderSellerPolicyPage.content';

import css from './LenderSellerPolicyPage.module.css';

const Block = ({ block }) => {
  if (block.h3) {
    return <h3 className={css.subheading}>{block.h3}</h3>;
  }
  if (block.list) {
    return (
      <ul className={css.list}>
        {block.list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.callout) {
    return (
      <div className={css.callout}>
        {block.callout.map((row, index) => (
          <div key={index} className={css.calloutRow}>
            <span className={css.calloutLabel}>{row.label}</span>
            <span className={css.calloutValue}>{row.value}</span>
          </div>
        ))}
      </div>
    );
  }
  if (block.boldLead) {
    return (
      <p>
        <strong>{block.boldLead}</strong>
        {block.p}
      </p>
    );
  }
  return <p>{block.p}</p>;
};

export const LenderSellerPolicyPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title="Lender & Seller Policy" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.content}>
          <h1 className={css.heading}>Lender & Seller Policy</h1>
          <p className={css.subtitle}>Rights, Responsibilities, Protections & Liabilities</p>
          <div className={css.meta}>
            <p>Nothing To Wear Club Inc. (operating as &quot;Nothing To Wear&quot;)</p>
            <p>
              Website: nothingtowearclub.ca &nbsp;|&nbsp; App: Nothing To Wear Club
            </p>
            <p>
              Effective Date: {EFFECTIVE_DATE} &nbsp;|&nbsp; Last Updated: {LAST_UPDATED}
            </p>
          </div>

          <p className={css.intro}>{INTRO}</p>

          {SECTIONS.map(section => (
            <section key={section.number} className={css.section}>
              <h2 className={css.sectionHeading}>
                {section.number}. {section.title}
              </h2>
              {section.blocks.map((block, index) => (
                <Block key={index} block={block} />
              ))}
            </section>
          ))}

          <section className={css.section}>
            <h2 className={css.sectionHeading}>
              {CONTACT.number}. {CONTACT.title}
            </h2>
            <p className={css.contact}>
              {CONTACT.companyLine}
              <br />
              Email: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              <br />
              Address: {CONTACT.address}
            </p>
          </section>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const LenderSellerPolicyPage = compose(connect(mapStateToProps))(LenderSellerPolicyPageComponent);

export default LenderSellerPolicyPage;
